import * as Sentry from "@sentry/react"
import type { CurrentUser } from "@/types/inertia"

/**
 * Initialise the browser Sentry SDK when a GlitchTip/Sentry DSN is present
 * on the page (injected at request time via layout meta tags). Safe to call
 * once at client boot; no-ops when the meta tag is missing.
 */
export function initSentryFromMeta(): void {
  if (typeof document === "undefined") return

  const dsn = document
    .querySelector('meta[name="sentry-dsn"]')
    ?.getAttribute("content")
  if (!dsn) return

  const environment =
    document
      .querySelector('meta[name="sentry-environment"]')
      ?.getAttribute("content") ?? undefined

  const rawRate = document
    .querySelector('meta[name="sentry-traces-sample-rate"]')
    ?.getAttribute("content")
  const tracesSampleRate = rawRate ? Number.parseFloat(rawRate) : 0.01

  Sentry.init({
    dsn,
    environment,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: Number.isFinite(tracesSampleRate)
      ? tracesSampleRate
      : 0.01,
    sendDefaultPii: false,
  })
}

/** Keep Sentry's user context aligned with Inertia's shared current_user. */
export function syncSentryUser(currentUser: CurrentUser): void {
  if (currentUser) {
    Sentry.setUser({
      id: String(currentUser.id),
      email: currentUser.email,
    })
  } else {
    Sentry.setUser(null)
  }
}
